import { Dayjs } from 'dayjs';
import React, { useState } from 'react';
import { CalendarFetchByDay } from '../../../../components/OrderListTable/CalendarFetch/CalendarFetchByDay';
import { Region } from '../../../../types/orderTypes';
import './LineHaulScanOverView.scss';
import { ScanMenuButtons } from '../ScanMenuButtons/ScanMenuButtons';
import { LineHaulDataComponents } from '../ScanPerformanceListWithLineHaul/ScanPerformanceListWithLineHaul';
import { showDayByHourOfDay } from '../showDayByHourOfDay';
import './LineHaulScanOverView.scss';
import { Helmet } from 'react-helmet';

export function LineHaulScanOverView({
  region,
}: {
  region: Region;
}): JSX.Element {
  const dayToSHow: Dayjs = showDayByHourOfDay();
  const [startDate, setStartDate] = useState(dayToSHow);

  const fetchValues = (givenDate: Dayjs) => {
    setStartDate(givenDate);
  };

  return (
    <div className="LineHaulScanOverView">
      <Helmet>
        <title>Monitor - Scan Line Haul</title>
      </Helmet>
      <ScanMenuButtons />

      <CalendarFetchByDay
        fetchValues={fetchValues}
        givenDate={startDate}
        trackingName={'LineHaulScanOverView-scan'}
      />

      <>
        <div className="flex-container">
          <LineHaulDataComponents forDate={startDate} />
        </div>
      </>
    </div>
  );
}
